import React from 'react'
import ReactDOM from 'react-dom'
import App from "./App.js"
import "./estilo.css"

ReactDOM.render(<App/>,document.getElementById("root"))